import React, { useState } from 'react'
import Modal from 'react-bootstrap/Modal'
import useSetAddBulletin from './hooks/useSetAddBulletin'
import { useLocation } from 'react-router-dom'
interface IModalProps {
    show: boolean
    onHide: () => void
    title?: string
    refetch: () => void
}
export default function AddBulletinModal({
    show,
    onHide,
    refetch,
}: IModalProps) {
    const [value, setValue] = useState<string>('')
    const { isLoading, mutate } = useSetAddBulletin(refetch)
    const { state } = useLocation()

    const handleSubmit = () => {
        const payload: IAddBulletinPayload = {
            id: state.moneyPool,
            text: value,
        }
        mutate(payload)
        onHide()
    }

    return (
        <Modal
            show={show}
            onHide={onHide}
            size="sm"
            aria-labelledby="contained-modal-title-vcenter"
            centered
        >
            <div className=" w-full text-center py-4 text-xs">
                <p className=" my-1">متن اعلام مورد نظر را بنویسید:</p>
                <p>(حداکثر پانصد حرف)</p>
                <hr className=" my-2" />
                <textarea
                    value={value}
                    onChange={(e) => setValue(e.target.value)}
                    placeholder="متن اعلام صندوق را در این قسمت بنویسید..."
                    className=" h-32 w-full outline-none text-center"
                />
                <hr className=" my-2" />
                <button
                    className=" text-xs text-current"
                    form="authProfile"
                    onClick={handleSubmit}
                >
                    تایید
                </button>
                <hr className=" my-2" />
                <p className=" text-xs cursor-pointer" onClick={onHide}>
                    انصراف
                </p>
            </div>
        </Modal>
    )
}
